import { useState } from "react";
import IndividualPerson from "./IndividualPerson";
import { IndividualPersonType } from "../../static/types/commonTypes/individualType";
import { initialIndividualState } from "../../static/initialState/commonInitialState/individualInitialState";

type IndividualListProps = {
  checked: boolean;
  individuals: IndividualPersonType[];
  addButtonText: string;
  removeButtonText: string;
  labelItem?: string;
  setIndividuals: (individuals: IndividualPersonType[]) => void;
  setIndividualsValidity: (isValid: boolean) => void;
};

export default function IndividualPersonList({
  checked,
  individuals,
  addButtonText,
  removeButtonText,
  labelItem,
  setIndividuals,
  setIndividualsValidity,
}: IndividualListProps) {
  const [listValidity, setListValidity] = useState<boolean[]>(
    individuals.map(() => false)
  );

  const addIndividual = () => {
    setIndividuals([...individuals, initialIndividualState]);
    setListValidity([...listValidity, false]);
  };

  const removeLastIndividual = () => {
    if (individuals.length > 1) {
      setIndividuals(individuals.slice(0, -1));
      setListValidity(listValidity.slice(0, -1));
    }
  };

  const updateIndividual = (index: number, updatedIndividual: IndividualPersonType) => {
    const newIndividuals = [...individuals];
    newIndividuals[index] = updatedIndividual;
    setIndividuals(newIndividuals);
  };

  const updateIndividualsValidity = (index: number, isValid: boolean) => {
    const newValidity = [...listValidity];
    newValidity[index] = isValid;
    setListValidity(newValidity);
    setIndividualsValidity(newValidity.every((valid) => valid));
  };

  return (
    <>
      <div className="mb-3 row">
        {individuals.map((individual, index) => (
          <div key={index} className="tab-content mb-2">
            <div className="mb-3 row pt-3">
              <div className="mb-3 row">
                <div className="col-sm-10">
                  {labelItem ? (
                    <h6 className="text-bold">{`${labelItem} ${index + 1}`}</h6>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>

            <IndividualPerson
              checked={checked}
              onValidationChange={(isValid: boolean) =>
                updateIndividualsValidity(index, isValid)
              }
              individual={individual}
              changeIndividual={(details) => {
                const updatedIndividual: IndividualPersonType = {
                  ...individual,
                  ...details,
                };
                updateIndividual(index, updatedIndividual);
              }}
            />
          </div>
        ))}
      </div>

      <div className="row mb-3">
        <div className="col d-flex justify-content-center align-items-center gap-5">
          <button type="button" onClick={addIndividual}>
            {addButtonText}
          </button>
          {individuals.length > 1 && (
            <button type="button" onClick={removeLastIndividual}>
              {removeButtonText}
            </button>
          )}
        </div>
      </div>
    </>
  );
}